/**
 * Premium Motion Engine
 * Handles IntersectionObserver reveals, staggered cascades, and scroll-velocity zooming.
 */
(function () {
  // 1. Reveal on Scroll (IntersectionObserver)
  var revealEls = document.querySelectorAll('[data-reveal]:not([data-reveal-init])');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (revealEls.length > 0) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { 
        el.classList.add('is-revealed'); 
        el.setAttribute('data-reveal-init', '1'); 
      });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

      revealEls.forEach(function (el) { 
        el.setAttribute('data-reveal-init', '1'); 
        io.observe(el); 
      });
    }
  }

  // 2. Scroll-Velocity Zoom
  // Calculates scroll speed and updates a global CSS variable --scroll-zoom.
  if (!reduceMotion) {
    var lastY = window.scrollY;
    var currentY = window.scrollY;
    var targetScale = 1;
    var currentScale = 1;
    var ticking = false;

    function updateZoom() {
      var dy = currentY - lastY;
      lastY = currentY;
      var velocity = Math.abs(dy);
      
      // Map velocity to scale (max scale 1.035 at velocity 60+)
      targetScale = 1 + Math.min(velocity / 60, 1) * 0.035;
      
      // Lerp (smooth ease) currentScale towards targetScale
      currentScale += (targetScale - currentScale) * 0.12;

      // If settled back to 1, stop ticking
      if (velocity < 1 && Math.abs(currentScale - 1) < 0.001) {
        currentScale = 1;
        document.documentElement.style.setProperty('--scroll-zoom', '1');
        ticking = false;
        return;
      }

      document.documentElement.style.setProperty('--scroll-zoom', currentScale.toFixed(4));
      requestAnimationFrame(updateZoom);
    }

    window.addEventListener('scroll', function () {
      currentY = window.scrollY;
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateZoom);
      }
    }, { passive: true });
  }

  // Listen for Shopify Theme Editor events to re-init
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      var newEls = document.querySelectorAll('[data-reveal]:not([data-reveal-init])');
      newEls.forEach(function(el) {
        el.classList.add('is-revealed'); // Just reveal them immediately in editor for simplicity
        el.setAttribute('data-reveal-init', '1');
      });
    });
  }
})();
